import { render, staticRenderFns } from "./PolicyPaymentList.vue?vue&type=template&id=514a01cb"
import script from "./PolicyPaymentList.vue?vue&type=script&lang=js"
export * from "./PolicyPaymentList.vue?vue&type=script&lang=js"
import style0 from "./PolicyPaymentList.vue?vue&type=style&index=0&id=514a01cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports